import { useTranslation } from 'react-i18next'
import { CustomerType } from 'src/api/api.generated'
import SimpleCustomerLookup, { SimpleCustomerLookupProps } from './simple-customer-lookup'

export type PersonLookupProps = Omit<SimpleCustomerLookupProps, 'customerType'>

export default function PersonLookup(props: PersonLookupProps) {
  const { t } = useTranslation()
  return (
    <SimpleCustomerLookup //
      customerType={CustomerType.PERSON}
      placeholder={t('pms.components.customer_lookup.create')}
      caption={t('pms.components.customer_lookup.name_input_tip')}
      noOptionsText={t('pms.components.customer_lookup.name_input_tip')}
      {...props}
    />
  )
}
